/**
=========================================================
* Astro Clean Carpets - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Astro Clean Carpets are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

import { lazy } from "react";

// @mui material components
import Icon from "@mui/material/Icon";

import { serviceAreaMap } from "pages/LandingPages/ServiceAreas/data";

// Pages
const CarpetCleaning = lazy(() => import("layouts/pages/landing-pages/carpet-cleaning"));
const ContactUs = lazy(() => import("layouts/pages/landing-pages/contact-us"));
const TileAndGroutCleaning = lazy(() => import("layouts/pages/landing-pages/tile-and-grout-cleaning"));
const UpholsteryCleaning = lazy(() => import("pages/LandingPages/UpholsteryCleaning"));
const SpotAndStainRemoval = lazy(() => import("pages/LandingPages/SpotAndStainRemoval"));
const StoneFloorCleaning = lazy(() => import("layouts/pages/landing-pages/stone-floor-cleaning"));
const HardwoodFloorCleaning = lazy(() => import("layouts/pages/landing-pages/hardwood-floor-cleaning"));
const AboutUs = lazy(() => import("layouts/pages/landing-pages/about-us"));
const FAQ = lazy(() => import("layouts/pages/landing-pages/faq"));
const ServiceAreas = lazy(() => import("layouts/pages/landing-pages/service-areas"));
const Reviews = lazy(() => import("layouts/pages/landing-pages/reviews"));
const AreaPage = lazy(() => import("pages/LandingPages/ServiceAreas/AreaPage"));

const routes = [
  {
    name: "services",
    icon: <Icon>dashboard</Icon>,
    columns: 2,
    rowsPerColumn: 4,
    collapse: [
      {
        name: "cleaning services",
        collapse: [
          {
            name: "carpet cleaning",
            route: "/pages/landing-pages/carpet-cleaning",
            component: <CarpetCleaning />,
          },
          {
            name: "tile and grout cleaning",
            route: "/pages/landing-pages/tile-and-grout-cleaning",
            component: <TileAndGroutCleaning />,
          },
          {
            name: "upholstery cleaning",
            route: "/pages/landing-pages/upholstery-cleaning",
            component: <UpholsteryCleaning />,
          },
          {
            name: "stone floor cleaning",
            route: "/pages/landing-pages/stone-floor-cleaning",
            component: <StoneFloorCleaning />,
          },
          {
            name: "hardwood floor cleaning",
            route: "/pages/landing-pages/hardwood-floor-cleaning",
            component: <HardwoodFloorCleaning />,
          },
          {
            name: "spot and stain removal",
            route: "/pages/landing-pages/spots-and-stain-removal",
            component: <SpotAndStainRemoval />,
          },
        ],
      },
      {
        name: "service areas",
        collapse: [
          {
            name: "all service areas",
            route: "/service-areas",
            component: <ServiceAreas />,
          },
          {
            name: "pierce county",
            route: "/service-areas/pierce-county",
            component: <AreaPage area={serviceAreaMap["pierce-county"]} />,
          },
          {
            name: "king county",
            route: "/service-areas/king-county",
            component: <AreaPage area={serviceAreaMap["king-county"]} />,
          },
          {
            name: "thurston county",
            route: "/service-areas/thurston-county",
            component: <AreaPage area={serviceAreaMap["thurston-county"]} />,
          },
          {
            name: "kitsap county",
            route: "/service-areas/kitsap-county",
            component: <AreaPage area={serviceAreaMap["kitsap-county"]} />,
          },
          {
            name: "mason county",
            route: "/service-areas/mason-county",
            component: <AreaPage area={serviceAreaMap["mason-county"]} />,
          },
        ],
      },
    ],
  },
  {
    name: "about us",
    icon: <Icon>article</Icon>,
    collapse: [
      {
        name: "about us",
        description: "Learn about our story, team, and commitment to quality",
        route: "/about-us",
        component: <AboutUs />,
      },
      {
        name: "FAQ",
        description: "Find answers to common carpet cleaning questions",
        route: "/faq",
        component: <FAQ />,
      },
      {
        name: "service areas",
        description: "Explore the counties and communities we serve",
        route: "/service-areas",
        component: <ServiceAreas />,
      },
      {
        name: "reviews",
        description: "Read customer reviews on Google and Facebook",
        route: "/reviews",
        component: <Reviews />,
      },
      {
        name: "contact us",
        description: "Give us a call to set an appointment",
        route: "/1/contact-us",
        component: <ContactUs />,
      },
    ],
  },
];

export default routes;
